import { useEffect, useMemo, useState } from 'react';
import './App.css';
import { createSession, getCase } from './DAL/dal';
import { initialStateAction } from './Redux/Case-reducer';
import { useDispatch } from 'react-redux';
import { Route, Routes } from 'react-router-dom';
import HeadInformation from './Components/HeadInformation';
import SurveyPlan from './Components/SurveyPlan';
import SurveyResults from './Components/SurveyResults';
import PrincipalDiagnosis from './Components/PrincipalDiagnosis';
import Treatment from './Components/Treatment';
import FutureTreatment from './Components/FutureTreatment';
import ResultsOfTreatment from './Components/ResultsOfTreatment';
import Excel from './Components/Excel';
import axios from 'axios';
import { v4 } from 'uuid'
import ProgressionFactors from './Components/ProgressionFactors';
import Finish from './Components/Finish';
import AlphaAdrenoblocker from './Components/AlphaAdrenoblocker';

function App() {
  const [start, setStart] = useState(false); // переключение с общей информации на первый визит к врачу
  const [useApp, setUseApp] = useState(false) // состояние не позволяющее в рамках одной сессии создать еще одну
  const [sessionId, setSessionId] = useState(v4())
  const [ip, setIp] = useState(null)
  const dispatch = useDispatch()
  const applicationId = useMemo(() => 1, []) // номер приложения для потягивания данных с сервера
  useEffect(() => {
    getCase(applicationId).then(r => {
      dispatch(initialStateAction(r.data))
      // console.log(r.data)
    })
  }, [])

  const devMode = false // режим разработки, когда не происходит отправки никаких запросов на сервер

  useEffect(() => {
    if (start && !useApp) {
      // отправка запроса на создание сессии после нажатии кнопки начать
      if (!devMode)
        createSession(sessionId, applicationId, ip).then(r => setUseApp(true)) // как только сессия создана, сразу закрываем возможность создать ее повторно
    }
  }, [start])

  useEffect(() => {
    axios.get('https://ipapi.co/json/').then(r => {
      setIp(r.data.ip)
    })
  }, [])

  return (
    <div className="App">
      <Routes>
        <Route path='/' element={<HeadInformation start={start} setStart={setStart} />} />
        <Route path='survey-plan' element={<SurveyPlan sessionId={sessionId} devMode={devMode} />} />
        <Route path='survey-results' element={<SurveyResults />} />
        <Route path='principal-diagnosis' element={<PrincipalDiagnosis sessionId={sessionId} devMode={devMode} />} />
        <Route path='progression-factors' element={<ProgressionFactors sessionId={sessionId} devMode={devMode} />} />
        <Route path='treatment' element={<Treatment sessionId={sessionId} devMode={devMode} />} />
        <Route path='alpha-adrenoblocker' element={<AlphaAdrenoblocker sessionId={sessionId} devMode={devMode} />} />
        <Route path='results-of-treatment' element={<ResultsOfTreatment sessionId={sessionId} devMode={devMode} />} />
        <Route path='future-treatment' element={<FutureTreatment sessionId={sessionId} devMode={devMode} />} />
        <Route path='finish' element={<Finish sessionId={sessionId} devMode={devMode} />} />
        <Route path='admin/:id' element={<Excel />} />
      </Routes>
    </div>
  );
}

export default App;
